import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, miniStats } from '../data/content';
import { Eyebrow } from './ui/Eyebrow';
export function Transformation() {
  return <section className="w-full bg-cream" data-id="element-177" data-mp="mluzci9x1yw4">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-178" data-mp="mktclgjjfnyk">
        <div className="text-center" data-id="element-179" data-mp="rlhbeoe0d93c">
          <Eyebrow data-id="element-180" data-mp="rmiqd3y5afqc">Twoja zmiana zaczyna się tutaj</Eyebrow>
          <h2 className="mx-auto mt-4 max-w-md font-display text-[26px] font-bold leading-[1.2] text-ink sm:text-[30px]" data-id="element-181" data-mp="wl3q729hixe9">
            Z przytłoczonego nauczyciela w{' '}
            <em className="font-display italic text-coral" data-id="element-182" data-mp="16a3un16rakzu">
              pewnego siebie eksperta.
            </em>
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-[13px] leading-relaxed text-muted" data-id="element-183" data-mp="1abyus2cyasc1">
            Plastyka Gotowa™ to kompletny system przygotowany przez nauczycieli
            dla nauczycieli. Zamiast szukać inspiracji po nocach, otwierasz
            moduł, wybierasz aktywność i wchodzisz do klasy z planem na całą
            lekcję.
          </p>
        </div>

        <dl className="mx-auto mt-10 grid max-w-lg grid-cols-3 divide-x divide-coral/20 rounded-xl border border-coral/20 bg-white/70 py-5" data-id="element-184" data-mp="176xc533jwdxa">
          {miniStats.map(stat => <div key={stat.label} className="px-3 text-center" data-id="element-185" data-mp="1376nb4xl47ve">
              <dt className="sr-only" data-id="element-186" data-mp="y7k7qouaafjf">{stat.label}</dt>
              <dd data-id="element-187" data-mp="1uw9sqo17jo9m">
                <span className="block font-display text-lg font-bold text-coral" data-id="element-188" data-mp="1uwrkb7cxdeb7">
                  {stat.value}
                </span>
                <span className="mt-0.5 block text-[9px] uppercase tracking-[0.14em] text-muted" data-id="element-189" data-mp="1qvpv7jcq2imy">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-10 rounded-2xl bg-white p-5 shadow-[0_24px_60px_-40px_rgba(36,28,24,0.4)] sm:p-7" data-id="element-190" data-mp="1h30kiqozx8so">
          <div className="grid gap-4 md:grid-cols-2" data-id="element-191" data-mp="2embtwk0u6qka">
            <div className="rounded-xl border border-sand bg-cream/60 p-5" data-id="element-192" data-mp="29t0ie5l2xlm1">
              <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-muted/70" data-id="element-193" data-mp="2spr7oe1mr461">
                Przed
              </p>
              <h3 className="mt-2 font-display text-base font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-194" data-mp="2xolxhzy0lszn">
                Konspekt zaczynany od zera
              </h3>
              <ul className="mt-4 space-y-2" data-id="element-195" data-mp="2ny989uf99bn6">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5 rounded-lg border border-sand/80 bg-white px-3 py-2.5 text-[11px] leading-snug text-muted" data-id="element-196" data-mp="29yhwm0c7o7cc">
                    <XIcon className="mt-0.5 h-3 w-3 shrink-0 text-muted/50" aria-hidden="true" data-id="element-197" data-mp="210fqx7hj8qiq" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="rounded-xl border border-coral/25 bg-coral-soft/50 p-5" data-id="element-198" data-mp="39d3ar8t4vgu">
              <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-coral" data-id="element-199" data-mp="1nquljzi0yq8b">
                Z Plastyką Gotową
              </p>
              <h3 className="mt-2 font-display text-base font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-200" data-mp="1jr3qvkpdnpyi">
                System gotowy do pracy
              </h3>
              <ul className="mt-4 space-y-2" data-id="element-201" data-mp="1spyy9045r63e">
                {afterItems.map(item => <li key={item} className="flex items-start gap-2.5 rounded-lg border border-coral/20 bg-white px-3 py-2.5 text-[11px] font-medium leading-snug text-ink" data-id="element-202" data-mp="27ebve0ezeuzh">
                    <CheckIcon className="mt-0.5 h-3 w-3 shrink-0 text-coral" aria-hidden="true" data-id="element-203" data-mp="2gf9qft7fzs5x" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="mt-5 text-center text-[10px] text-muted/80" data-id="element-204" data-mp="h3qo3xgn9i58">
            Wszystko, czego potrzebujesz, w jednym pliku PDF — otwórz i prowadź.
          </p>
        </div>
      </div>
    </section>;
}